import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PartnerContext } from 'Admin/utils';
import { useStore } from '../store';

export const useReattributionRedirect = () => {
  const { currentPartner } = useContext(PartnerContext);
  const [state] = useStore();
  const history = useHistory();
  const [canViewRoute, setCanViewRoute] = useState<boolean>(false);

  useEffect(() => {
    if (state.policies.selections.length === 0 && currentPartner) {
      history.replace(`/admin/partners/${currentPartner.id}/reattribution`);
    } else {
      setCanViewRoute(true);
    }
    // we don't want to run this when the state changes, but we do need to check for currentPartner changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPartner]);

  return canViewRoute;
};
